// Live Mode rollout gate.
//
// Which surfaces expose a real Live entry (push-to-talk full-screen presence on
// the Espelho, Conv AI later). Everything NOT in this set renders the
// "coming soon" + waitlist badge regardless of tier.
//
// Launch (Option C): only the Espelho ("mirror") is Live-enabled, Premium-gated.
// The four mini-mirror module keys (calendar / fitness / nutrition / brain) stay
// OUT → coming-soon. Brain's Live entry is removed entirely this release.
//
// Adding a module here flips its badge from "coming soon" to the Premium-gated
// live status — no other code change needed (MiniMirrorLiveButton reads this).

export type LiveModule =
  | "mirror"
  | "calendar"
  | "fitness"
  | "nutrition"
  | "brain"
  | "language";

export const LIVE_ENABLED_MODULES: ReadonlySet<LiveModule> = new Set<LiveModule>([
  "mirror",
]);

/** True when the module has a real Live surface enabled (else: coming soon). */
export function isLiveEnabledModule(module: string): boolean {
  return LIVE_ENABLED_MODULES.has(module as LiveModule);
}
